import HallUI from "./HallUI";
import PopWindowManager from "../Shared/PopWindowManager";
import AudioManager from "../Shared/AudioManager";

const {ccclass, property} = cc._decorator;

@ccclass
export default class BaoxiangAni extends cc.Component {
    @property(cc.Node)
    hengfu:cc.Node = null;
    @property(cc.Label)
    labHengfu:cc.Label = null;
    @property(cc.Node)
    goldIcon:cc.Node = null;
    @property(sp.Skeleton)
    baoxiangAni: sp.Skeleton = null;
    @property(sp.Skeleton)
    bgAni: sp.Skeleton = null;
    @property(sp.Skeleton)
    liziAni:sp.Skeleton = null;
    private endPos: any;

    onLoad () {
        this.liziAni.setCompleteListener(this.liziComplete.bind(this));
    }

    start () {

    }

    onEnable(): void {
        this.liziAni.animation = "tx_lizi";
        this.baoxiangAni.animation = "baoxiang_chuxian";
        this.bgAni.animation = "tx_guang";

    }

    updateMoney(money,endPos){
        this.endPos = endPos;
        this.labHengfu.string = money;
        this.scheduleOnce(function () {
            this.node.getComponent(cc.Animation).play("baoxiangAni");
        }.bind(this),0.8);

    }

    baoxiangComplete(){
        console.log();
        this.bgAni.node.active = true;
        this.liziAni.node.active = true;
    }
    liziComplete(){
        //this.node.active  = false;
    }

    playGoldAnimal (ePos, cb?) {
        let interval = 0.07;
        var nodeArr = [];
        var goldCount = 10;

        for (let i = 0; i < goldCount; ++i) {
            let gold = cc.instantiate(this.goldIcon);
            //gold.active = true;
            nodeArr.push(gold);
            nodeArr[i].parent = this.node;
            var pos = new cc.Vec2(this.node.getPosition().x ,this.node.getPosition().y);
            nodeArr[i].setPosition(pos);
        }
        let k = 0;
        var delay = interval * goldCount;
        var self = this;
        var callFunc = function () {

            nodeArr[k].active = true;
            var pos = new cc.Vec2(ePos.x, ePos.y );
            nodeArr[k].runAction(cc.sequence(cc.moveTo(delay - k * interval, pos),
                cc.callFunc(function () {
                    cc.log("===执行动画完成k：",k);
                    nodeArr[k] && (nodeArr[k].active = false);

            }.bind(this))));
            k++;
        };
        this.schedule(callFunc.bind(this), interval,goldCount-1);
        this.scheduleOnce(function () {
            cb();
        }.bind(this),interval *goldCount + 0.5)
    }

    onBtnClick(event,param){
        AudioManager.playSound("button");
        cc.log("===点击领取按钮");
        this.playGoldAnimal(this.endPos,function(){
            PopWindowManager.openNext();
            this.node.destroy();
        }.bind(this));
    }

}
